module.exports = __webpack_public_path__ + "img/baner_free_shipping_mb.0b207ab6.jpg";